import { useMutation, UseMutationOptions, useQueryClient } from '@tanstack/react-query';
import api from '../../api';
import { CreateOrder } from '@/types/api/order';

type TData = { id: string };
type TVariables = CreateOrder;

export function useCreateOrderMutation(options?: UseMutationOptions<TData, Error, TVariables>) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: ['create-order'],
    mutationFn: (data: TVariables) => api.order.create(data),
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: ['orders'],
      });
    },
    ...options,
  });
}
